import { gql } from '@apollo/client';

export const CREATE_VORLAGE_ABSCHNITT = gql`
  mutation mitarbeiter_createVorlageAbschnitt(
    $input: mitarbeiter_createVorlageAbschnittInput!
  ) {
    mitarbeiter_createVorlageAbschnitt(createVorlageAbschnittInput: $input) {
      success {
        vorlageAbschnitt {
          id
          name
          position
        }
      }
      error {
        message
      }
    }
  }
`;
